
        var result = require("!!../../../../node_modules/css-loader/index.js!./arrival-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/arrival-list/arrival-list.component.css
// module id = 576
// module chunks = 0